/* House of Vyasa: small behaviours on top of Dawn. No dependencies.
   - dedication live preview (+ second copy for the pack variant)
   - surprise-gift toggle
   - add-ons added alongside the book; Buy now that skips the cart
   - sticky mobile bar
   - countdown to real deadlines
   - cart drawer pack upsell and second dedication
   - spin-wheel offer popup with a stored, non-resetting expiry
   - see-inside slider arrows, autoplay of the first product video */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  var routesOr = function (key, fallback) { return (window.routes && window.routes[key]) || fallback; };

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong');
        return data;
      });
    });
  }

  /* ---------- dedication preview ---------- */
  function initDedication(root) {
    var plate = $('[data-hov-plate]', root);
    var active = '1';
    function paint(groupId) {
      if (!plate) return;
      var group = $('[data-hov-group="' + groupId + '"]', root);
      if (!group) return;
      ['for', 'message', 'from'].forEach(function (f) {
        var input = $('[data-hov-field="' + f + '"]', group);
        var out = $('[data-hov-out="' + f + '"]', plate);
        if (!input || !out) return;
        var sampleKey = f === 'for' && groupId === '2' ? 'sampleFor2' : 'sample' + f.charAt(0).toUpperCase() + f.slice(1);
        var val = input.value.trim();
        out.textContent = val || plate.dataset[sampleKey] || '';
        out.dataset.sample = val ? 'false' : 'true';
      });
    }
    $$('[data-hov-group]', root).forEach(function (group) {
      var id = group.dataset.hovGroup;
      group.addEventListener('input', function (e) {
        active = id;
        var counter = $('[data-hov-count]', group);
        var msg = $('[data-hov-field="message"]', group);
        if (counter && msg) counter.textContent = msg.value.length + '/160';
        if (e.target.matches('[data-hov-field]')) paint(id);
      });
      group.addEventListener('focusin', function () { if (active !== id) { active = id; paint(id); } });
    });
    root._hovPaint = function () { paint(active); };
  }

  function togglePackFields(sectionId, variant) {
    $$('[data-hov-ded][data-section="' + sectionId + '"]').forEach(function (root) {
      var box = $('[data-hov-copy2]', root);
      if (!box) return;
      var packTitle = (box.dataset.packTitle || '').trim();
      var on = !!(variant && packTitle && String(variant.title).trim().toLowerCase() === packTitle);
      box.hidden = !on;
      $$('input, textarea', box).forEach(function (el) { el.disabled = !on; });
      if (!on && root._hovPaint) {
        var first = $('[data-hov-group="1"] [data-hov-field="for"]', root);
        if (first) first.dispatchEvent(new Event('focusin', { bubbles: true }));
      }
    });
  }

  /* ---------- surprise gift ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-hov-gift]')) {
      var wrap = t.closest('[data-hov-gift-wrap]');
      var note = wrap && $('[data-hov-gift-note]', wrap);
      if (note) {
        note.hidden = !t.checked;
        $$('textarea', note).forEach(function (el) { el.disabled = !t.checked; });
      }
    }
  });

  /* ---------- add to cart with add-ons, and Buy now ---------- */
  function checkedAddons(sectionId) {
    return $$('[data-hov-addons="' + sectionId + '"] input[data-hov-addon]:checked');
  }

  function buildItems(sectionId) {
    var form = document.getElementById('product-form-' + sectionId);
    if (!form) throw new Error('Product form not found');
    var fd = new FormData(form);
    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && String(value).trim() !== '') props[m[1]] = value;
    });
    var id = fd.get('id');
    if (!id) throw new Error(window.variantStrings ? window.variantStrings.unavailable : 'Unavailable');
    var items = [{ id: Number(id), quantity: Number(fd.get('quantity')) || 1, properties: props }];
    checkedAddons(sectionId).forEach(function (el) { items.push({ id: Number(el.value), quantity: 1 }); });
    return items;
  }

  function goToCheckout() {
    // Behave exactly like the cart's own checkout button, so GoKwik (which hooks
    // name="checkout" buttons) takes over; Shopify's checkout otherwise.
    var form = document.createElement('form');
    form.method = 'post';
    form.action = routesOr('cart_url', '/cart');
    form.hidden = true;
    var btn = document.createElement('button');
    btn.type = 'submit';
    btn.name = 'checkout';
    form.appendChild(btn);
    document.body.appendChild(form);
    btn.click();
  }

  function showFormError(sectionId, message) {
    var wrap = $('#MainProduct-' + sectionId + ' .product-form__error-message-wrapper');
    if (wrap) {
      wrap.hidden = false;
      var msg = $('.product-form__error-message', wrap);
      if (msg) msg.textContent = message;
    } else {
      window.alert(message);
    }
  }

  function addItems(sectionId, opts) {
    var items = buildItems(sectionId);
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && !opts.checkout) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return postJSON(routesOr('cart_add_url', '/cart/add') + '.js', body).then(function (res) {
      if (opts.checkout) return goToCheckout();
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        window.location = routesOr('cart_url', '/cart');
      }
    });
  }

  function withLoading(btn, promise) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    return promise.catch(function (err) { return err; }).then(function (err) {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
      if (err instanceof Error) throw err;
    });
  }

  function buyNow(sectionId, btn) {
    var dynamic = $('#MainProduct-' + sectionId + ' .shopify-payment-button__button');
    if (!checkedAddons(sectionId).length && dynamic && !dynamic.disabled) {
      dynamic.click();
      return;
    }
    withLoading(btn, addItems(sectionId, { checkout: true })).catch(function (err) { showFormError(sectionId, err.message); });
  }

  // Add to cart: when add-ons are ticked, add everything in one request.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.id || form.id.indexOf('product-form-') !== 0) return;
    var sectionId = form.id.replace('product-form-', '');
    if (!checkedAddons(sectionId).length) return; // Dawn handles the plain case
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = $('[name="add"]', form) || $('.product-form__submit', form);
    withLoading(btn, addItems(sectionId, { checkout: false })).catch(function (err) { showFormError(sectionId, err.message); });
  }, true);

  // Dynamic checkout (Buy now) with add-ons ticked: add everything, then check out.
  document.addEventListener('click', function (e) {
    var pay = e.target.closest && e.target.closest('.shopify-payment-button');
    if (!pay) return;
    var info = pay.closest('product-info');
    if (!info) return;
    var sectionId = info.dataset.section;
    if (!checkedAddons(sectionId).length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    withLoading(null, addItems(sectionId, { checkout: true })).catch(function (err) { showFormError(sectionId, err.message); });
  }, true);

  // Sticky bar
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hov-buy]');
    if (!btn || btn.disabled) return;
    var sectionId = btn.dataset.hovBuy;
    if (btn.dataset.action === 'add_to_cart') {
      var form = document.getElementById('product-form-' + sectionId);
      var submit = form && ($('[name="add"]', form) || $('[type="submit"]', form));
      if (submit) submit.click();
      return;
    }
    buyNow(sectionId, btn);
  });

  function initSticky() {
    var bar = $('[data-hov-sticky]');
    if (!bar) return;
    document.body.classList.add('hov-has-sticky');
    if (bar.dataset.mobileOnly === 'true') document.body.classList.add('hov-sticky-mobile-only');
  }

  // Keep our variant-dependent bits in step with Dawn's variant picker.
  function onVariantChange(event) {
    var data = event && event.data;
    if (!data) return;
    var sectionId = data.sectionId;
    togglePackFields(sectionId, data.variant);
    ['HovStickyPrice-', 'HovScarcity-'].forEach(function (prefix) {
      var current = document.getElementById(prefix + sectionId);
      var fresh = data.html && data.html.getElementById(prefix + sectionId);
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    });
    $$('[data-hov-buy="' + sectionId + '"]').forEach(function (b) { b.disabled = !(data.variant && data.variant.available); });
  }

  /* ---------- countdown to real deadlines ---------- */
  function parseDeadlines(raw) {
    return String(raw || '').split(/\r?\n/).map(function (line) {
      var parts = line.split('|');
      var when = (parts[0] || '').trim();
      if (!when) return null;
      var iso = when.replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) iso += 'T23:59';
      if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(iso)) iso += '+05:30'; // store time is IST unless an offset is given
      var t = Date.parse(iso);
      return isNaN(t) ? null : { t: t, label: (parts[1] || '').trim() };
    }).filter(Boolean).sort(function (a, b) { return a.t - b.t; });
  }

  function fmtLeft(ms) {
    var m = Math.max(0, Math.floor(ms / 60000));
    var d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
    if (d > 0) return d + 'd ' + h + 'h';
    if (h > 0) return h + 'h ' + mm + 'm';
    return mm + 'm';
  }

  function fmtClock(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return p(h) + ':' + p(m) + ':' + p(sec);
  }

  function initCountdowns() {
    var els = $$('[data-hov-countdown]');
    if (!els.length) return;
    function tick() {
      var now = Date.now();
      els.forEach(function (el) {
        var next = parseDeadlines(el.dataset.deadlines).filter(function (d) { return d.t > now; })[0];
        var text = $('[data-hov-countdown-text]', el);
        if (!next || !text) { el.hidden = true; return; }
        text.textContent = '';
        text.appendChild(document.createTextNode((el.dataset.prefix || '') + ' '));
        var strong = document.createElement('strong');
        strong.textContent = fmtLeft(next.t - now);
        text.appendChild(strong);
        if (next.label) text.appendChild(document.createTextNode(' ' + next.label));
        el.hidden = false;
      });
    }
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- cart drawer: pack upsell and second dedication ---------- */
  function drawerSections() {
    var drawer = document.querySelector('cart-drawer');
    return drawer ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }
  function renderDrawer(res) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && res.sections) drawer.renderContents(res);
    else window.location.reload();
  }
  function showErr(box, err) {
    var p = $('[data-hov-err]', box);
    if (p) { p.textContent = err.message; p.hidden = false; }
  }

  document.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-hov-upsell-go]');
    if (go) {
      var box = go.closest('[data-hov-upsell]');
      var props = JSON.parse(box.dataset.props || '{}');
      withLoading(go,
        postJSON(routesOr('cart_change_url', '/cart/change') + '.js', { id: box.dataset.key, quantity: 0 })
          .then(function () {
            return postJSON(routesOr('cart_add_url', '/cart/add') + '.js', {
              items: [{ id: Number(box.dataset.pack), quantity: 1, properties: props }],
              sections: drawerSections(),
              sections_url: window.location.pathname
            });
          })
          .then(renderDrawer)
      ).catch(function (err) { showErr(box, err); });
      return;
    }
    var save = e.target.closest && e.target.closest('[data-hov-copy2-save]');
    if (save) {
      var form = save.closest('[data-hov-copy2-form]');
      var existing = JSON.parse(form.dataset.props || '{}');
      $$('[data-field]', form).forEach(function (el) {
        if (el.value.trim()) existing[el.dataset.field] = el.value.trim();
      });
      withLoading(save,
        postJSON(routesOr('cart_change_url', '/cart/change') + '.js', {
          id: form.dataset.key,
          quantity: Number(form.dataset.qty) || 1,
          properties: existing,
          sections: drawerSections(),
          sections_url: window.location.pathname
        }).then(renderDrawer)
      ).catch(function (err) { showErr(form, err); });
    }
  });

  /* ---------- see-inside slider arrows ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hov-slide]');
    if (!b) return;
    var track = document.getElementById(b.getAttribute('aria-controls'));
    if (!track) return;
    var slide = track.firstElementChild;
    var step = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    track.scrollBy({ left: b.dataset.hovSlide === 'next' ? step : -step, behavior: 'smooth' });
  });

  /* ---------- autoplay the first product video, muted ---------- */
  function autoplayFirstVideo() {
    if (!document.body.dataset.hovAutoplay) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var first = $('.product__media-list .product__media-item');
    var dm = first && $('deferred-media', first);
    if (!dm || typeof dm.loadContent !== 'function') return;
    var tpl = $('template', dm);
    var video = tpl && tpl.content.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    dm.loadContent(false);
    var live = $('video', dm);
    if (live) { live.muted = true; var p = live.play(); if (p && p.catch) p.catch(function () {}); }
  }

  /* ---------- offer popup (spin wheel) ---------- */
  var OFFER = 'hov_offer';          // {code,label,revealedAt,expiresAt}: set once, never re-rolled
  var PENDING = 'hov_offer_pending'; // {code,label}: chosen when the number is submitted
  var DISMISSED = 'hov_offer_dismissed';

  function parseCodes(raw) {
    return String(raw || '').split(/\r?\n/).map(function (line) {
      var p = line.split('|').map(function (s) { return s.trim(); });
      if (!p[0]) return null;
      return { code: p[0], label: p[1] || p[0], weight: Math.max(0, parseFloat(p[2]) || 1) };
    }).filter(Boolean);
  }

  function pickCode(codes) {
    var total = codes.reduce(function (s, c) { return s + c.weight; }, 0);
    var r = Math.random() * total;
    for (var i = 0; i < codes.length; i++) { r -= codes[i].weight; if (r <= 0) return codes[i]; }
    return codes[codes.length - 1];
  }

  function wheelSVG(codes) {
    var segs = codes.slice();
    while (segs.length < 6) segs = segs.concat(codes);
    var n = segs.length, R = 100, c = 110, step = 360 / n;
    var pt = function (a, r) {
      var rad = (a * Math.PI) / 180;
      return (c + r * Math.sin(rad)).toFixed(2) + ' ' + (c - r * Math.cos(rad)).toFixed(2);
    };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); };
    var out = '<svg viewBox="0 0 220 220" role="img" aria-label="Offer wheel"><circle cx="110" cy="110" r="108" fill="#4A0B0E" stroke="#C9A24A" stroke-width="2"/>';
    segs.forEach(function (s, i) {
      var a0 = i * step, a1 = (i + 1) * step, mid = a0 + step / 2;
      out += '<path d="M110 110 L' + pt(a0, R) + ' A' + R + ' ' + R + ' 0 0 1 ' + pt(a1, R) + ' Z" fill="' + (i % 2 ? '#7E1518' : '#5c0f12') + '" stroke="#C9A24A" stroke-width=".8"/>';
      out += '<text x="110" y="' + (110 - R * 0.62) + '" transform="rotate(' + mid + ' 110 110)" text-anchor="middle" dominant-baseline="middle" fill="#E7CF8E" font-family="Spectral, Georgia, serif" font-size="' + (n > 8 ? 9 : 11) + '">' + esc(s.label) + '</text>';
    });
    out += '<circle cx="110" cy="110" r="16" fill="#C9A24A"/><circle cx="110" cy="110" r="6" fill="#4A0B0E"/></svg>';
    return { html: out, segs: segs, step: step };
  }

  function applyURL(code, redirect) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect || '/');
  }

  function initOffer() {
    var dlg = $('[data-hov-offer]');
    var pill = $('[data-hov-offer-pill]');
    if (!dlg) return;
    var codes = parseCodes(dlg.dataset.codes);
    if (!codes.length) return;
    var hours = Number(dlg.dataset.hours) || 24;
    var redirect = dlg.dataset.applyRedirect || '/';
    var offer = store.get(OFFER);
    var timer;

    function paintPill() {
      if (!pill) return;
      var o = store.get(OFFER);
      if (!o || o.expiresAt <= Date.now()) { pill.hidden = true; return; }
      $('[data-hov-pill-code]', pill).textContent = o.label + ' · ' + o.code;
      $('[data-hov-pill-timer]', pill).textContent = fmtClock(o.expiresAt - Date.now());
      pill.href = applyURL(o.code, redirect);
      pill.hidden = false;
    }

    function paintReveal() {
      var o = store.get(OFFER);
      if (!o) return;
      $('[data-hov-offer-code]', dlg).textContent = o.code;
      $('[data-hov-offer-label]', dlg).textContent = o.label;
      $('[data-hov-offer-timer]', dlg).textContent = fmtClock(o.expiresAt - Date.now());
      $('[data-hov-offer-apply]', dlg).href = applyURL(o.code, redirect);
    }

    function startClock() {
      clearInterval(timer);
      timer = setInterval(function () { paintPill(); if (dlg.open) paintReveal(); }, 1000);
      paintPill();
    }

    function open() {
      if (dlg.open || typeof dlg.showModal !== 'function') return;
      dlg.showModal();
    }
    function close() {
      if (dlg.open) dlg.close();
      if (!store.get(OFFER)) store.set(DISMISSED, Date.now());
    }
    $$('[data-hov-offer-close]', dlg).forEach(function (b) { b.addEventListener('click', close); });
    dlg.addEventListener('cancel', function () { if (!store.get(OFFER)) store.set(DISMISSED, Date.now()); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

    var wheel = wheelSVG(codes);
    var staticWheel = $('[data-hov-wheel]', dlg);
    if (staticWheel) staticWheel.innerHTML = wheel.html;

    // Already revealed in this browser: never re-roll, only show what is left.
    if (offer) {
      if (offer.expiresAt > Date.now()) startClock();
      return;
    }

    // Choose the code when the number is submitted, before Shopify reloads the page.
    var form = $('#HovOfferForm', dlg) || $('form', dlg);
    if (form) {
      form.addEventListener('submit', function (e) {
        var phone = $('[name="contact[phone]"]', form);
        if (phone && !phone.checkValidity()) { e.preventDefault(); phone.reportValidity(); return; }
        if (!store.get(PENDING)) {
          var c = pickCode(codes);
          store.set(PENDING, { code: c.code, label: c.label });
        }
      });
    }

    var pending = store.get(PENDING);
    var posted = !!$('[data-hov-offer-posted]', dlg);
    var hasErrors = !!$('[data-hov-offer-errors]', dlg);

    if (posted && pending) {
      // Number captured: spin to the chosen code, then store the reveal time once.
      $('[data-hov-offer-step="form"]', dlg).hidden = true;
      var reveal = $('[data-hov-offer-step="reveal"]', dlg);
      reveal.hidden = false;
      var spinBox = $('[data-hov-wheel-spin]', reveal);
      spinBox.innerHTML = wheel.html;
      var svg = $('svg', spinBox);
      var idx = wheel.segs.map(function (s) { return s.code; }).indexOf(pending.code);
      if (idx < 0) idx = 0;
      var target = 360 * 5 + (360 - (idx * wheel.step + wheel.step / 2));
      open();
      var finish = function () {
        var now = Date.now();
        store.set(OFFER, { code: pending.code, label: pending.label, revealedAt: now, expiresAt: now + hours * 3600000 });
        store.del(PENDING);
        fetch(applyURL(pending.code, '/'), { credentials: 'same-origin' }).catch(function () {}); // auto-apply
        paintReveal();
        startClock();
      };
      requestAnimationFrame(function () {
        svg.style.transform = 'rotate(' + target + 'deg)';
        setTimeout(finish, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 4300);
      });
      $('[data-hov-offer-code]', reveal).textContent = '';
      return;
    }

    if (hasErrors) { open(); return; }

    var path = window.location.pathname;
    if (/\/(cart|checkout|account)/.test(path)) return;
    var dismissed = store.get(DISMISSED);
    var reshowMs = (Number(dlg.dataset.reshowDays) || 3) * 86400000;
    if (dismissed && Date.now() - dismissed < reshowMs) return;

    var delay = (Number(dlg.dataset.delay) || 20) * 1000;
    setTimeout(open, delay);
    if (dlg.dataset.exit === 'true' && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(); }
      });
    }
  }

  /* ---------- boot ---------- */
  function boot() {
    $$('[data-hov-ded]').forEach(initDedication);
    initSticky();
    initCountdowns();
    initOffer();
    autoplayFirstVideo();
    // Dawn declares these as top-level script bindings (constants.js, pubsub.js).
    /* global subscribe, PUB_SUB_EVENTS */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
